export const RIO_COLOR_STRINGS = {
  spectral: 'spectral',
  rPlumbo: 'rplumbo',
  cFastie: 'cfastie',
  schwarzwald: 'schwarzwald',
  viridis: 'viridis',
  redYellowGreen: 'rdylgn',
  binary: 'binary',
  binaryReverse: 'binary_r',
  YellowOrangeRed: 'ylorrd',
  YellowGreen: 'ylgn',
  plasma: 'plasma',
  RedYellowBlue: 'rdylbu',
  BluesReverse: 'blues_r', // not the genre
  jet: 'jet',
  jetReverse: 'jet_r',
  ndwi: 'ndwi',
  yellowGreenBlue: 'ylgnbu',
  turbo: 'turbo',
  gnbu: 'gnbu'
};
